import { createWidgetMixin } from 'vue-instantsearch';
import { connectHits } from 'instantsearch.js/es/connectors';
import { fbFunctions } from "@/config/firebase";

import {
    AisInstantSearch,
    AisRefinementList,
    AisHits,
    AisHighlight,
    AisSearchBox,
    AisStats,
    AisPagination,
    AisConfigure,
} from 'vue-instantsearch';
import {i18n} from "@/i18n";

export default {
    mixins: [
        createWidgetMixin({ connector: connectHits })
    ],
    components: {
        AisInstantSearch,
        AisRefinementList,
        AisHits,
        AisHighlight,
        AisSearchBox,
        AisStats,
        AisPagination,
        AisConfigure
    },
    methods: {
        deleteReport(reportId) {
            let saveMaintenanceMode = fbFunctions.httpsCallable('apiAdmin');
            Swal.fire(
                i18n.t("administration.admin.global.modal_save_in_progress_title"),
                i18n.t("administration.admin.global.modal_save_in_progress_content"),
                "warning"
            );
            saveMaintenanceMode({
                type: 'deleteReport',
                parameters: {
                    reportId: reportId,
                }
            })
            .then(function(result) {
                if(result.data === "SUCCESS_USER_REPORT_DELETED") {
                    swal.fire(
                        i18n.t("administration.admin.global.modal_save_success_title"),
                        i18n.t("administration.admin.global.modal_save_success_content"),
                        "success"
                    )
                }
            })
            .catch((e) => {
                swal.fire(
                    i18n.t("administration.admin.global.modal_save_error_title"),
                    i18n.t("administration.admin.global.modal_save_error_content"),
                    "error"
                )
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/administration/admin/app-reported-users/components/users-custom-hit/users-custom-hit.js